import React from 'react';
import Icon from '../lib/Icon';

/** Reusable explainer of the access model — positive, methodological framing. */
export default function ConfidentialityNote({ compact }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 12,
      padding: compact ? '12px 14px' : '16px 18px',
      borderRadius: 'var(--radius-md)', background: 'var(--neutral-50)', border: '1px solid var(--line)',
    }}>
      <span style={{
        display: 'inline-flex', width: 30, height: 30, flex: 'none', alignItems: 'center', justifyContent: 'center',
        borderRadius: 'var(--radius-md)', background: 'var(--human-50)', color: 'var(--human-600)',
      }}>
        <Icon name="users" size={16} />
      </span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-bold)', fontSize: 'var(--text-sm)', letterSpacing: 'var(--track-tight)', marginBottom: 3 }}>
          Individual scores stay with the coach — by design
        </div>
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--ink-soft)', lineHeight: 'var(--lh-snug)', textWrap: 'pretty' }}>
          Private results protect candor, which is what makes the cohort data trustworthy. As the program owner
          you see participation and aggregate movement here; named individual results go only to the independent coach.
        </div>
      </div>
    </div>
  );
}
